<h2 mat-dialog-title class="vh-title">Version History</h2>
<div mat-dialog-content class="history-wrapper">
  <div *ngIf="loading" class="loading">Loading history...</div>
  <div *ngIf="error" class="error">{{ error }}</div>
  <div *ngIf="!loading && !error && lifecycle.length === 0" class="empty">
    No changes recorded for this request yet.
  </div>

  <div *ngIf="!loading && !error && lifecycle.length" class="lifecycle-list">
    <div *ngIf="createdAt" class="created-row">
      <span class="created-label">Event created:</span>
      <span class="created-date">{{ createdAt | date:'short' }}</span>
    </div>
    <div *ngFor="let entry of lifecycle; let i = index">
      <div class="lifecycle-entry" [class.expanded]="expanded.has(i)">
        <div class="entry-header" (click)="toggleExpand(i)">
          <div class="timestamp">{{ entry.timestamp | date:'short' }}</div>
          <div class="user">{{ entry.user }}</div>
          <div class="summary">{{ entry.summary }}</div>
          <div class="count">{{ entry.event_id }}</div>
          <button mat-icon-button color="primary" (click)="toggleExpand(i); $event.stopPropagation();">
            <mat-icon>{{ expanded.has(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
        <div class="entry-details">
          <!-- <table class="detail-table" *ngIf="entry.changes.length"> -->

            <table class="detail-table" *ngIf="expanded.has(i)">
            <thead>
              <tr>
                <th>What Changed</th>
                <th>Old Value</th>
                <th>New Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of entry.changes">
                <td>{{ c.fieldLabel  }}</td>
                <td *ngIf="c.fieldLabel == 'start_date' || c.fieldLabel == 'end_date'">
                  {{ c.oldValue | date:'yyyy-MM-dd HH:mm:ss' }}
                </td>
                <td *ngIf="c.fieldLabel == 'start_date' || c.fieldLabel == 'end_date'">
                  {{ c.newValue | date:'yyyy-MM-dd HH:mm:ss' }}
                </td>
                <td *ngIf="c.fieldLabel != 'start_date' && c.fieldLabel != 'end_date'">
                  {{ c.oldValue === '' || c.oldValue == null ? '—' : c.oldValue }}
                </td>
                <td *ngIf="c.fieldLabel != 'start_date' && c.fieldLabel != 'end_date'">
                  {{ c.newValue === '' || c.newValue == null ? '—' : c.newValue }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()">Close</button>
</div>
